module.exports = "<img src=\"/static/img/event.png\">\n";


//////////////////
// WEBPACK FOOTER
// ./src/assets/copy/landing_image.md
// module id = byzt
// module chunks = 0